import tw, { styled } from 'twin.macro';

export const PageTitle = styled.h1`
  ${tw`font-saira`};
  ${tw`text-primary-purple`}
  ${tw`font-semibold`}
  ${tw`text-lg`}
  ${tw`mb-16`}
`;

export const Wrapper = styled.div`
  ${tw`max-w-[1200px] min-w-[860px] m-auto pl-24 pt-16`};
`;

export const ContentWrapper = styled.div`
  ${tw`pr-96`}
`;
